// @flow
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { exportData, setForm, deleteAccount } from '../../../actions';
import {
    DELETE_ACCOUNT_FORM,
    EXPORT_DATA_FORM,
    MY_ACCOUNT_FORM,
} from '../../../constants/forms';
import Form from '../../../ui/components/Forms/GdprPassword';

type Props = {
    type: string,
    branding: Object,
    params: Object,
    language: string,
    resetExportMessage: Function,
    exportData: Function,
    setFrom: Function,
    deleteAccount: Function,
};

export class ConfirmAction extends Component<Props> {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            active: false,
        };
    }

    back = () => {
        if (this.props.type === 'delete') {
            this.props.setForm(DELETE_ACCOUNT_FORM);
        } else {
            this.props.setForm(EXPORT_DATA_FORM);
        }
    };

    exportData = ({ password }) => {
        this.props.exportData(password, () =>
            this.props.setForm(MY_ACCOUNT_FORM)
        );
    };

    deleteAccount = ({ password }) => {
        this.props.deleteAccount(password);
    };

    handleFocus = e => {
        e.preventDefault();
        this.setState({
            name: e.target.name,
            active: !this.state.active,
        });
    };

    render() {
        const { branding, params, auth } = this.props;

        return (
            <Form
                onSubmit={
                    this.props.type === 'delete'
                        ? this.deleteAccount
                        : this.exportData
                }
                back={this.back}
                branding={branding}
                params={params}
                handleFocus={this.handleFocus}
                active={this.state.active}
                name={this.state.name}
                lng={this.props.language}
                isLoading={auth.isLoadingButton}
            />
        );
    }
}

const mapStateToProps = (state: Object) => {
    return {
        branding: state.branding,
        params: state.form.gdprPasswordForm,
        auth: state.auth,
    };
};

export default connect(
    mapStateToProps,
    {
        exportData,
        setForm,
        deleteAccount,
    }
)(ConfirmAction);



// WEBPACK FOOTER //
// ./src/containers/Forms/GDPR/ConfirmAction.js